<div class="tag {{ type }}"><ng-content></ng-content></div>
